var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "payment"
  }, [_c('Header'), _c('div', {
    staticClass: "content paymentcont"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', [_c('i', {
    staticClass: "iconfont icontijiaochenggong"
  }), _c('h3', [_c('p', [_vm._v("订单提交成功！请尽快完成支付哦～")]), _c('p', [_vm._v(" 请在 "), _c('CountDown', {
    attrs: {
      "time": _vm.surplus,
      "format": "hh:mm:ss"
    }
  }), _vm._v("内完成支付，超时将取消订单 ")], 1)])]), _c('span', [_vm._v(" 支付金额： "), _c('b', [_vm._v("¥" + _vm._s(_vm.totalPrice))])])]), _c('div', {
    staticClass: "selectpay"
  }, [_c('p', [_vm._v("请选择以下支付方式")]), _c('ul', [_c('li', {
    class: {
      'active': _vm.radio === 1
    },
    on: {
      "click": function click($event) {
        return _vm.selectPay(1);
      }
    }
  }, [_c('em'), _vm._m(0)]), _c('li', {
    class: {
      'active': _vm.radio === 2
    },
    on: {
      "click": function click($event) {
        return _vm.selectPay(2);
      }
    }
  }, [_c('em'), _vm._m(1)])])]), _c('div', {
    staticClass: "gopay",
    on: {
      "click": _vm.gopay
    }
  }, [_vm._v("去支付")]), _c('div', {
    ref: "qrCodeUrl",
    staticClass: "qrcode"
  })]), _c('Footer')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', [_c('i', {
    staticClass: "iconfont iconzhifubao"
  }), _c('b', [_vm._v("支付宝")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', [_c('i', {
    staticClass: "iconfont iconweixinzhifu"
  }), _c('b', [_vm._v("微信")])]);
}];
export { render, staticRenderFns };